// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-enter {
  animation: fade-in 0.35s ease-out;
}

.user-theme {
  background: #ff8a00 !important;
  color: #111111 !important;
}

.user-theme * {
  color: #111111 !important;
  border-color: #6b3f00 !important;
}

.user-theme .bg-slate-950,
.user-theme .bg-slate-900,
.user-theme .bg-slate-800,
.user-theme .bg-red-950\\/20,
.user-theme .bg-blue-600,
.user-theme .bg-blue-700,
.user-theme .bg-transparent {
  background: #ffd6a1 !important;
}

.user-theme .hover\\:bg-red-900\\/40:hover,
.user-theme .hover\\:bg-blue-700:hover,
.user-theme .hover\\:bg-orange-600:hover,
.user-theme .hover\\:bg-zinc-900:hover {
  background: #ffc67d !important;
}

.user-theme input,
.user-theme textarea,
.user-theme select {
  background: #fff1dc !important;
  color: #111111 !important;
}

.user-theme input::placeholder,
.user-theme textarea::placeholder {
  color: #111111aa !important;
}

.user-theme .text-slate-400,
.user-theme .text-slate-500,
.user-theme .text-blue-300,
.user-theme .text-red-300,
.user-theme .text-orange-500,
.user-theme .text-orange-400 {
  color: #3b2500 !important;
}

/* 2026-02-13 — Strategy Performance Page bypass: bu sayfada renk
   farklılığı kritik (LONG/SHORT/kâr/zarar), \`.user-theme *\` ile siyaha
   düşmemeli. Wrapper'a \`data-strategy-perf-bypass="true"\` koyduğumuzda
   tüm Tailwind text-/border-/bg- renkleri tekrar görünür hale gelir. */
[data-strategy-perf-bypass="true"] {
  background: #1e293b !important;
  color: #e2e8f0 !important;
  border-radius: 0.5rem;
  padding: 1rem;
}
[data-strategy-perf-bypass="true"] * {
  color: revert !important;
  border-color: revert !important;
}
[data-strategy-perf-bypass="true"] .text-foreground {
  color: #f1f5f9 !important;
}
[data-strategy-perf-bypass="true"] .text-muted-foreground {
  color: #94a3b8 !important;
}
[data-strategy-perf-bypass="true"] .text-emerald-300 { color: #6ee7b7 !important; }
[data-strategy-perf-bypass="true"] .text-emerald-400 { color: #34d399 !important; }
[data-strategy-perf-bypass="true"] .text-rose-300 { color: #fda4af !important; }
[data-strategy-perf-bypass="true"] .text-rose-400 { color: #fb7185 !important; }
[data-strategy-perf-bypass="true"] .text-amber-300 { color: #fcd34d !important; }
[data-strategy-perf-bypass="true"] .text-blue-300 { color: #93c5fd !important; }
[data-strategy-perf-bypass="true"] .text-indigo-300 { color: #a5b4fc !important; }
[data-strategy-perf-bypass="true"] .text-violet-300 { color: #c4b5fd !important; }
[data-strategy-perf-bypass="true"] .text-slate-300 { color: #cbd5e1 !important; }
[data-strategy-perf-bypass="true"] [class*="bg-emerald-500"] { background-color: rgba(16, 185, 129, 0.15) !important; }
[data-strategy-perf-bypass="true"] [class*="bg-rose-500"] { background-color: rgba(244, 63, 94, 0.15) !important; }
[data-strategy-perf-bypass="true"] [class*="bg-amber-500"] { background-color: rgba(245, 158, 11, 0.15) !important; }
[data-strategy-perf-bypass="true"] [class*="bg-blue-500"] { background-color: rgba(59, 130, 246, 0.15) !important; }
[data-strategy-perf-bypass="true"] [class*="bg-indigo-500"] { background-color: rgba(99, 102, 241, 0.15) !important; }
[data-strategy-perf-bypass="true"] [class*="bg-violet-500"] { background-color: rgba(139, 92, 246, 0.15) !important; }
[data-strategy-perf-bypass="true"] [class*="bg-slate-500"] { background-color: rgba(100, 116, 139, 0.15) !important; }
[data-strategy-perf-bypass="true"] [class*="bg-gray-500"] { background-color: rgba(107, 114, 128, 0.15) !important; }
[data-strategy-perf-bypass="true"] .border-emerald-500\\/40 { border-color: rgba(16, 185, 129, 0.5) !important; }
[data-strategy-perf-bypass="true"] .border-rose-500\\/40 { border-color: rgba(244, 63, 94, 0.5) !important; }
[data-strategy-perf-bypass="true"] .border-border { border-color: #334155 !important; }
[data-strategy-perf-bypass="true"] .border-dashed { border-style: dashed !important; border-color: #475569 !important; }
[data-strategy-perf-bypass="true"] [data-slot="card"],
[data-strategy-perf-bypass="true"] .rounded-xl {
  background: #0f172a !important;
  border: 1px solid #334155 !important;
}
[data-strategy-perf-bypass="true"] button {
  color: #e2e8f0 !important;
}

.admin-ops-theme {
  background: #ff8a00 !important;
  color: #111111 !important;
}

.admin-ops-theme * {
  color: #111111 !important;
  border-color: #6b3f00 !important;
}

.admin-ops-theme .bg-slate-950,
.admin-ops-theme .bg-slate-900,
.admin-ops-theme .bg-slate-800,
.admin-ops-theme .bg-red-950\\/20,
.admin-ops-theme .bg-blue-600,
.admin-ops-theme .bg-blue-700,
.admin-ops-theme .bg-transparent {
  background: #ffd6a1 !important;
}

.admin-ops-theme .text-slate-400,
.admin-ops-theme .text-slate-500,
.admin-ops-theme .text-blue-300,
.admin-ops-theme .text-red-300,
.admin-ops-theme .text-orange-500,
.admin-ops-theme .text-orange-400 {
  color: #3b2500 !important;
}

.admin-ops-theme .hover\\:bg-red-900\\/40:hover,
.admin-ops-theme .hover\\:bg-blue-700:hover,
.admin-ops-theme .hover\\:bg-orange-600:hover,
.admin-ops-theme .hover\\:bg-zinc-900:hover,
.admin-ops-theme .hover\\:bg-zinc-700:hover,
.admin-ops-theme .hover\\:bg-red-700:hover,
.admin-ops-theme .hover\\:bg-red-800:hover {
  background: #ffc67d !important;
}

.admin-ops-theme button.bg-black,
.admin-ops-theme button[class*=" bg-black"],
.admin-ops-theme button[class^="bg-black"] {
  background: #b7f7a8 !important;
  color: #0e2c14 !important;
  border-color: #3a6f3a !important;
}

.admin-ops-theme button[class*="hover:bg-zinc-800"]:hover,
.admin-ops-theme button[class*="hover:bg-zinc-900"]:hover,
.admin-ops-theme button[class*="hover:bg-black"]:hover {
  background: #9de98a !important;
  color: #0b2611 !important;
}

.admin-ops-theme [data-testid*="submit-button"],
.admin-ops-theme [data-testid*="save-button"],
.admin-ops-theme [data-testid*="apply-button"],
.admin-ops-theme [data-testid*="config-update-button"] {
  background: #4caf50 !important;
  color: #ffffff !important;
  border-color: #2f7d32 !important;
}

.admin-ops-theme [data-testid*="submit-button"]:hover,
.admin-ops-theme [data-testid*="save-button"]:hover,
.admin-ops-theme [data-testid*="apply-button"]:hover,
.admin-ops-theme [data-testid*="config-update-button"]:hover {
  background: #43a047 !important;
  color: #ffffff !important;
}

.admin-ops-theme input,
.admin-ops-theme select,
.admin-ops-theme textarea,
.admin-ops-theme [role="combobox"] {
  background-color: #dff7df !important;
  border: 1px solid #6bbf6b !important;
  color: #1e3d1e !important;
}

.admin-ops-theme input[class*="bg-"],
.admin-ops-theme select[class*="bg-"],
.admin-ops-theme textarea[class*="bg-"],
.admin-ops-theme [role="combobox"][class*="bg-"] {
  background-color: #dff7df !important;
}

.admin-ops-theme input:focus,
.admin-ops-theme select:focus,
.admin-ops-theme textarea:focus,
.admin-ops-theme [role="combobox"]:focus {
  background-color: #eaffea !important;
  border-color: #38a538 !important;
  outline: none !important;
}

.admin-ops-theme input[class*="bg-"]:focus,
.admin-ops-theme select[class*="bg-"]:focus,
.admin-ops-theme textarea[class*="bg-"]:focus,
.admin-ops-theme [role="combobox"][class*="bg-"]:focus {
  background-color: #eaffea !important;
}

.admin-ops-theme input::placeholder,
.admin-ops-theme textarea::placeholder {
  color: #6a8f6a !important;
}

.admin-ops-theme input:disabled,
.admin-ops-theme select:disabled,
.admin-ops-theme textarea:disabled {
  background-color: #edf5ed !important;
  color: #8ca88c !important;
}

.admin-ops-theme .react-select__control {
  background-color: #dff7df !important;
  border-color: #6bbf6b !important;
}

.admin-ops-theme .react-select__menu {
  background-color: #eaffea !important;
}

.admin-ops-theme .react-select__option {
  color: #1e3d1e !important;
}

.admin-ops-theme .table-filter input {
  background-color: #dff7df !important;
}

.admin-ops-theme .card input,
.admin-ops-theme .card select,
.admin-ops-theme .card textarea {
  background-color: #dff7df !important;
}

.admin-ops-theme button.primary {
  background-color: #4caf50 !important;
  color: white !important;
}

.admin-ops-theme button.primary:hover {
  background-color: #3f9f44 !important;
}

/* Admin content area: açık yeşil panel yüzeyleri (sidebar/navbar hariç) */
.admin-light-panels {
  background: #eafbe7 !important;
  color: #11331a !important;
}

.admin-light-panels [class*="bg-slate-"],
.admin-light-panels [class*="bg-zinc-"],
.admin-light-panels [class*="bg-neutral-"],
.admin-light-panels [class*="bg-stone-"],
.admin-light-panels [class*="bg-gray-"],
.admin-light-panels [class*="bg-black"],
.admin-light-panels [class*="bg-transparent"] {
  background: #d8f7d1 !important;
  color: #11331a !important;
}

.admin-light-panels [class*="border-slate-"],
.admin-light-panels [class*="border-zinc-"],
.admin-light-panels [class*="border-neutral-"],
.admin-light-panels [class*="border-gray-"],
.admin-light-panels [class*="border-black"] {
  border-color: #6ebd72 !important;
}

.admin-light-panels input,
.admin-light-panels textarea,
.admin-light-panels select,
.admin-light-panels [role="combobox"] {
  background: #efffe9 !important;
  color: #11331a !important;
  border-color: #64b86a !important;
}

.admin-light-panels button {
  background: #b5efaa !important;
  color: #0f2f13 !important;
  border-color: #4e9d53 !important;
}

.admin-light-panels button:hover {
  background: #a3e79a !important;
}

.admin-light-panels [class*="text-slate-"],
.admin-light-panels [class*="text-zinc-"],
.admin-light-panels [class*="text-neutral-"],
.admin-light-panels [class*="text-gray-"] {
  color: #11331a !important;
}

.admin-light-panels [class*="from-slate-"],
.admin-light-panels [class*="from-zinc-"],
.admin-light-panels [class*="from-black"] {
  --tw-gradient-from: #d8f7d1 !important;
  --tw-gradient-to: rgb(216 247 209 / 0) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}

.admin-light-panels [class*="via-slate-"],
.admin-light-panels [class*="via-zinc-"],
.admin-light-panels [class*="via-black"] {
  --tw-gradient-stops: var(--tw-gradient-from), #cef2c6, var(--tw-gradient-to) !important;
}

.admin-light-panels [class*="to-slate-"],
.admin-light-panels [class*="to-zinc-"],
.admin-light-panels [class*="to-black"] {
  --tw-gradient-to: #c6edbe !important;
}

.user-theme :focus-visible,
.admin-ops-theme :focus-visible {
  outline: 2px solid #065f46 !important;
  outline-offset: 2px;
  border-radius: 4px;
}

.user-theme [aria-label],
.admin-ops-theme [aria-label] {
  scroll-margin-top: 84px;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-group {
  margin-bottom: 14px;
}

.form-label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  font-size: 0.86rem;
}

.form-helper-text {
  margin-top: 4px;
  font-size: 0.72rem;
  line-height: 1.3;
}

.form-error-text {
  margin-top: 4px;
  font-size: 0.72rem;
  line-height: 1.3;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;;;;;EAOE,8BAA8B;AAChC;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;uEAGuE;AACvE;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA,uDAAuD,yBAAyB,EAAE;AAClF,uDAAuD,yBAAyB,EAAE;AAClF,oDAAoD,yBAAyB,EAAE;AAC/E,oDAAoD,yBAAyB,EAAE;AAC/E,qDAAqD,yBAAyB,EAAE;AAChF,oDAAoD,yBAAyB,EAAE;AAC/E,sDAAsD,yBAAyB,EAAE;AACjF,sDAAsD,yBAAyB,EAAE;AACjF,qDAAqD,yBAAyB,EAAE;AAChF,+DAA+D,qDAAqD,EAAE;AACtH,4DAA4D,oDAAoD,EAAE;AAClH,6DAA6D,qDAAqD,EAAE;AACpH,4DAA4D,qDAAqD,EAAE;AACnH,8DAA8D,qDAAqD,EAAE;AACrH,8DAA8D,qDAAqD,EAAE;AACrH,6DAA6D,sDAAsD,EAAE;AACrH,4DAA4D,sDAAsD,EAAE;AACpH,6DAA6D,gDAAgD,EAAE;AAC/G,0DAA0D,+CAA+C,EAAE;AAC3G,oDAAoD,gCAAgC,EAAE;AACtF,oDAAoD,+BAA+B,EAAE,gCAAgC,EAAE;AACvH;;EAEE,8BAA8B;EAC9B,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;;;;;EAOE,8BAA8B;AAChC;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,8BAA8B;AAChC;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;;;EAIE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;;EAIE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;;;EAIE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,0EAA0E;AAC1E;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;;;;EAKE,gCAAgC;AAClC;;AAEA;;;;EAIE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;EAGE,sCAAsC;EACtC,iDAAiD;EACjD,8EAA8E;AAChF;;AAEA;;;EAGE,uFAAuF;AACzF;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;EAEE,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".page-enter {\n  animation: fade-in 0.35s ease-out;\n}\n\n.user-theme {\n  background: #ff8a00 !important;\n  color: #111111 !important;\n}\n\n.user-theme * {\n  color: #111111 !important;\n  border-color: #6b3f00 !important;\n}\n\n.user-theme .bg-slate-950,\n.user-theme .bg-slate-900,\n.user-theme .bg-slate-800,\n.user-theme .bg-red-950\\/20,\n.user-theme .bg-blue-600,\n.user-theme .bg-blue-700,\n.user-theme .bg-transparent {\n  background: #ffd6a1 !important;\n}\n\n.user-theme .hover\\:bg-red-900\\/40:hover,\n.user-theme .hover\\:bg-blue-700:hover,\n.user-theme .hover\\:bg-orange-600:hover,\n.user-theme .hover\\:bg-zinc-900:hover {\n  background: #ffc67d !important;\n}\n\n.user-theme input,\n.user-theme textarea,\n.user-theme select {\n  background: #fff1dc !important;\n  color: #111111 !important;\n}\n\n.user-theme input::placeholder,\n.user-theme textarea::placeholder {\n  color: #111111aa !important;\n}\n\n.user-theme .text-slate-400,\n.user-theme .text-slate-500,\n.user-theme .text-blue-300,\n.user-theme .text-red-300,\n.user-theme .text-orange-500,\n.user-theme .text-orange-400 {\n  color: #3b2500 !important;\n}\n\n/* 2026-02-13 — Strategy Performance Page bypass: bu sayfada renk\n   farklılığı kritik (LONG/SHORT/kâr/zarar), `.user-theme *` ile siyaha\n   düşmemeli. Wrapper'a `data-strategy-perf-bypass=\"true\"` koyduğumuzda\n   tüm Tailwind text-/border-/bg- renkleri tekrar görünür hale gelir. */\n[data-strategy-perf-bypass=\"true\"] {\n  background: #1e293b !important;\n  color: #e2e8f0 !important;\n  border-radius: 0.5rem;\n  padding: 1rem;\n}\n[data-strategy-perf-bypass=\"true\"] * {\n  color: revert !important;\n  border-color: revert !important;\n}\n[data-strategy-perf-bypass=\"true\"] .text-foreground {\n  color: #f1f5f9 !important;\n}\n[data-strategy-perf-bypass=\"true\"] .text-muted-foreground {\n  color: #94a3b8 !important;\n}\n[data-strategy-perf-bypass=\"true\"] .text-emerald-300 { color: #6ee7b7 !important; }\n[data-strategy-perf-bypass=\"true\"] .text-emerald-400 { color: #34d399 !important; }\n[data-strategy-perf-bypass=\"true\"] .text-rose-300 { color: #fda4af !important; }\n[data-strategy-perf-bypass=\"true\"] .text-rose-400 { color: #fb7185 !important; }\n[data-strategy-perf-bypass=\"true\"] .text-amber-300 { color: #fcd34d !important; }\n[data-strategy-perf-bypass=\"true\"] .text-blue-300 { color: #93c5fd !important; }\n[data-strategy-perf-bypass=\"true\"] .text-indigo-300 { color: #a5b4fc !important; }\n[data-strategy-perf-bypass=\"true\"] .text-violet-300 { color: #c4b5fd !important; }\n[data-strategy-perf-bypass=\"true\"] .text-slate-300 { color: #cbd5e1 !important; }\n[data-strategy-perf-bypass=\"true\"] [class*=\"bg-emerald-500\"] { background-color: rgba(16, 185, 129, 0.15) !important; }\n[data-strategy-perf-bypass=\"true\"] [class*=\"bg-rose-500\"] { background-color: rgba(244, 63, 94, 0.15) !important; }\n[data-strategy-perf-bypass=\"true\"] [class*=\"bg-amber-500\"] { background-color: rgba(245, 158, 11, 0.15) !important; }\n[data-strategy-perf-bypass=\"true\"] [class*=\"bg-blue-500\"] { background-color: rgba(59, 130, 246, 0.15) !important; }\n[data-strategy-perf-bypass=\"true\"] [class*=\"bg-indigo-500\"] { background-color: rgba(99, 102, 241, 0.15) !important; }\n[data-strategy-perf-bypass=\"true\"] [class*=\"bg-violet-500\"] { background-color: rgba(139, 92, 246, 0.15) !important; }\n[data-strategy-perf-bypass=\"true\"] [class*=\"bg-slate-500\"] { background-color: rgba(100, 116, 139, 0.15) !important; }\n[data-strategy-perf-bypass=\"true\"] [class*=\"bg-gray-500\"] { background-color: rgba(107, 114, 128, 0.15) !important; }\n[data-strategy-perf-bypass=\"true\"] .border-emerald-500\\/40 { border-color: rgba(16, 185, 129, 0.5) !important; }\n[data-strategy-perf-bypass=\"true\"] .border-rose-500\\/40 { border-color: rgba(244, 63, 94, 0.5) !important; }\n[data-strategy-perf-bypass=\"true\"] .border-border { border-color: #334155 !important; }\n[data-strategy-perf-bypass=\"true\"] .border-dashed { border-style: dashed !important; border-color: #475569 !important; }\n[data-strategy-perf-bypass=\"true\"] [data-slot=\"card\"],\n[data-strategy-perf-bypass=\"true\"] .rounded-xl {\n  background: #0f172a !important;\n  border: 1px solid #334155 !important;\n}\n[data-strategy-perf-bypass=\"true\"] button {\n  color: #e2e8f0 !important;\n}\n\n.admin-ops-theme {\n  background: #ff8a00 !important;\n  color: #111111 !important;\n}\n\n.admin-ops-theme * {\n  color: #111111 !important;\n  border-color: #6b3f00 !important;\n}\n\n.admin-ops-theme .bg-slate-950,\n.admin-ops-theme .bg-slate-900,\n.admin-ops-theme .bg-slate-800,\n.admin-ops-theme .bg-red-950\\/20,\n.admin-ops-theme .bg-blue-600,\n.admin-ops-theme .bg-blue-700,\n.admin-ops-theme .bg-transparent {\n  background: #ffd6a1 !important;\n}\n\n.admin-ops-theme .text-slate-400,\n.admin-ops-theme .text-slate-500,\n.admin-ops-theme .text-blue-300,\n.admin-ops-theme .text-red-300,\n.admin-ops-theme .text-orange-500,\n.admin-ops-theme .text-orange-400 {\n  color: #3b2500 !important;\n}\n\n.admin-ops-theme .hover\\:bg-red-900\\/40:hover,\n.admin-ops-theme .hover\\:bg-blue-700:hover,\n.admin-ops-theme .hover\\:bg-orange-600:hover,\n.admin-ops-theme .hover\\:bg-zinc-900:hover,\n.admin-ops-theme .hover\\:bg-zinc-700:hover,\n.admin-ops-theme .hover\\:bg-red-700:hover,\n.admin-ops-theme .hover\\:bg-red-800:hover {\n  background: #ffc67d !important;\n}\n\n.admin-ops-theme button.bg-black,\n.admin-ops-theme button[class*=\" bg-black\"],\n.admin-ops-theme button[class^=\"bg-black\"] {\n  background: #b7f7a8 !important;\n  color: #0e2c14 !important;\n  border-color: #3a6f3a !important;\n}\n\n.admin-ops-theme button[class*=\"hover:bg-zinc-800\"]:hover,\n.admin-ops-theme button[class*=\"hover:bg-zinc-900\"]:hover,\n.admin-ops-theme button[class*=\"hover:bg-black\"]:hover {\n  background: #9de98a !important;\n  color: #0b2611 !important;\n}\n\n.admin-ops-theme [data-testid*=\"submit-button\"],\n.admin-ops-theme [data-testid*=\"save-button\"],\n.admin-ops-theme [data-testid*=\"apply-button\"],\n.admin-ops-theme [data-testid*=\"config-update-button\"] {\n  background: #4caf50 !important;\n  color: #ffffff !important;\n  border-color: #2f7d32 !important;\n}\n\n.admin-ops-theme [data-testid*=\"submit-button\"]:hover,\n.admin-ops-theme [data-testid*=\"save-button\"]:hover,\n.admin-ops-theme [data-testid*=\"apply-button\"]:hover,\n.admin-ops-theme [data-testid*=\"config-update-button\"]:hover {\n  background: #43a047 !important;\n  color: #ffffff !important;\n}\n\n.admin-ops-theme input,\n.admin-ops-theme select,\n.admin-ops-theme textarea,\n.admin-ops-theme [role=\"combobox\"] {\n  background-color: #dff7df !important;\n  border: 1px solid #6bbf6b !important;\n  color: #1e3d1e !important;\n}\n\n.admin-ops-theme input[class*=\"bg-\"],\n.admin-ops-theme select[class*=\"bg-\"],\n.admin-ops-theme textarea[class*=\"bg-\"],\n.admin-ops-theme [role=\"combobox\"][class*=\"bg-\"] {\n  background-color: #dff7df !important;\n}\n\n.admin-ops-theme input:focus,\n.admin-ops-theme select:focus,\n.admin-ops-theme textarea:focus,\n.admin-ops-theme [role=\"combobox\"]:focus {\n  background-color: #eaffea !important;\n  border-color: #38a538 !important;\n  outline: none !important;\n}\n\n.admin-ops-theme input[class*=\"bg-\"]:focus,\n.admin-ops-theme select[class*=\"bg-\"]:focus,\n.admin-ops-theme textarea[class*=\"bg-\"]:focus,\n.admin-ops-theme [role=\"combobox\"][class*=\"bg-\"]:focus {\n  background-color: #eaffea !important;\n}\n\n.admin-ops-theme input::placeholder,\n.admin-ops-theme textarea::placeholder {\n  color: #6a8f6a !important;\n}\n\n.admin-ops-theme input:disabled,\n.admin-ops-theme select:disabled,\n.admin-ops-theme textarea:disabled {\n  background-color: #edf5ed !important;\n  color: #8ca88c !important;\n}\n\n.admin-ops-theme .react-select__control {\n  background-color: #dff7df !important;\n  border-color: #6bbf6b !important;\n}\n\n.admin-ops-theme .react-select__menu {\n  background-color: #eaffea !important;\n}\n\n.admin-ops-theme .react-select__option {\n  color: #1e3d1e !important;\n}\n\n.admin-ops-theme .table-filter input {\n  background-color: #dff7df !important;\n}\n\n.admin-ops-theme .card input,\n.admin-ops-theme .card select,\n.admin-ops-theme .card textarea {\n  background-color: #dff7df !important;\n}\n\n.admin-ops-theme button.primary {\n  background-color: #4caf50 !important;\n  color: white !important;\n}\n\n.admin-ops-theme button.primary:hover {\n  background-color: #3f9f44 !important;\n}\n\n/* Admin content area: açık yeşil panel yüzeyleri (sidebar/navbar hariç) */\n.admin-light-panels {\n  background: #eafbe7 !important;\n  color: #11331a !important;\n}\n\n.admin-light-panels [class*=\"bg-slate-\"],\n.admin-light-panels [class*=\"bg-zinc-\"],\n.admin-light-panels [class*=\"bg-neutral-\"],\n.admin-light-panels [class*=\"bg-stone-\"],\n.admin-light-panels [class*=\"bg-gray-\"],\n.admin-light-panels [class*=\"bg-black\"],\n.admin-light-panels [class*=\"bg-transparent\"] {\n  background: #d8f7d1 !important;\n  color: #11331a !important;\n}\n\n.admin-light-panels [class*=\"border-slate-\"],\n.admin-light-panels [class*=\"border-zinc-\"],\n.admin-light-panels [class*=\"border-neutral-\"],\n.admin-light-panels [class*=\"border-gray-\"],\n.admin-light-panels [class*=\"border-black\"] {\n  border-color: #6ebd72 !important;\n}\n\n.admin-light-panels input,\n.admin-light-panels textarea,\n.admin-light-panels select,\n.admin-light-panels [role=\"combobox\"] {\n  background: #efffe9 !important;\n  color: #11331a !important;\n  border-color: #64b86a !important;\n}\n\n.admin-light-panels button {\n  background: #b5efaa !important;\n  color: #0f2f13 !important;\n  border-color: #4e9d53 !important;\n}\n\n.admin-light-panels button:hover {\n  background: #a3e79a !important;\n}\n\n.admin-light-panels [class*=\"text-slate-\"],\n.admin-light-panels [class*=\"text-zinc-\"],\n.admin-light-panels [class*=\"text-neutral-\"],\n.admin-light-panels [class*=\"text-gray-\"] {\n  color: #11331a !important;\n}\n\n.admin-light-panels [class*=\"from-slate-\"],\n.admin-light-panels [class*=\"from-zinc-\"],\n.admin-light-panels [class*=\"from-black\"] {\n  --tw-gradient-from: #d8f7d1 !important;\n  --tw-gradient-to: rgb(216 247 209 / 0) !important;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;\n}\n\n.admin-light-panels [class*=\"via-slate-\"],\n.admin-light-panels [class*=\"via-zinc-\"],\n.admin-light-panels [class*=\"via-black\"] {\n  --tw-gradient-stops: var(--tw-gradient-from), #cef2c6, var(--tw-gradient-to) !important;\n}\n\n.admin-light-panels [class*=\"to-slate-\"],\n.admin-light-panels [class*=\"to-zinc-\"],\n.admin-light-panels [class*=\"to-black\"] {\n  --tw-gradient-to: #c6edbe !important;\n}\n\n.user-theme :focus-visible,\n.admin-ops-theme :focus-visible {\n  outline: 2px solid #065f46 !important;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.user-theme [aria-label],\n.admin-ops-theme [aria-label] {\n  scroll-margin-top: 84px;\n}\n\n@keyframes fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.form-group {\n  margin-bottom: 14px;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 600;\n  font-size: 0.86rem;\n}\n\n.form-helper-text {\n  margin-top: 4px;\n  font-size: 0.72rem;\n  line-height: 1.3;\n}\n\n.form-error-text {\n  margin-top: 4px;\n  font-size: 0.72rem;\n  line-height: 1.3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
